import React, { useReducer, useState } from "react";
import {Toast} from "./Toast";
import {
    ToastContextProviderType,
    ToastContextValue,
    ToastPropsType,
    ToastType,
} from "./Toast.types";
import { toastReducer } from "./reducer/toast.reducer";
import { styles } from "./Toast.styles";
import { uuid } from "components/lib/utils";
import { Stack } from "components/lib/layouts/Stack/Stack";

export const createToastContext = () =>
    React.createContext({} as ToastContextValue);

export function ToastManager({
    context: ToastContext,
    children,
}: ToastContextProviderType) {
    const [toasts, dispatch] = useReducer(toastReducer, []);
    const [isToasting, _setIsToasting] = useState(toasts.length > 0);

    const addToast = (toast: ToastPropsType) => {
        const id = toast.id || uuid();
        dispatch({
            type: "ADD_TOAST",
            payload: { ...toast, id },
        });
        _setIsToasting(true);
        return id;
    };

    const removeToast = (toastId: string) => {
        dispatch({
            type: "DELETE_TOAST",
            payload: toastId,
        });
        _setIsToasting(toasts.length > 1);
    };

    const updateToast = (updatedToast: ToastType) => {
        dispatch({
            type: "UPDATE_TOAST",
            payload: updatedToast,
        });
    };

    return (
        <ToastContext.Provider value={{ addToast, removeToast, updateToast, isToasting }}>
            {children}
            <Stack direction="vertical" gap={2} styles={styles.ToastsContainer}>
                {toasts.map(toast => {
                    const { id } = toast;
                    return (
                        <Toast
                            key={id}
                            {...toast}
                            onCloseToast={() => removeToast(id)}
                        />
                    );
                })}
            </Stack>
        </ToastContext.Provider>
    );
}
